import React from 'react';
import { CtaButton } from '../CtaButton';
export function Solution() {
  return <section className="bg-brand-900 px-5 py-16 text-center sm:py-24" data-id="element-314" data-mp="3hg0xc2103k11">
      <div className="mx-auto max-w-3xl" data-id="element-315" data-mp="3hhvkzo3npq8t">
        <p className="text-xs font-bold uppercase tracking-[0.16em] text-gold sm:text-sm" data-id="element-316" data-mp="7xgcxlkthfx">
          And you don’t necessarily need more information
        </p>
        <h2 className="mt-4 font-display text-[30px] font-bold leading-[1.12] text-white sm:text-5xl" data-id="element-317" data-mp="3rgbaxnqy6tgq">
          You may already have <em className="text-brand-200" data-id="element-318" data-mp="49iqwcan1jmy">enough.</em>
        </h2>
        <p className="mt-6 text-[17px] leading-relaxed text-brand-100 sm:text-lg" data-id="element-319" data-mp="4767rvt5938b">
          The problem is that knowing a technique doesn’t necessarily mean knowing{' '}
          <strong className="text-white" data-id="element-320" data-mp="e0debjzmep9z">when, how and in what order</strong> to use it within a personal practice.
        </p>
        <p className="mt-8 text-[17px] text-brand-100" data-id="element-321" data-mp="rwqu8ooiaimc">That’s why I created the:</p>
        <p className="mt-2 font-display text-3xl font-extrabold text-white sm:text-5xl" data-id="element-322" data-mp="nz2v19fs63on">7D Apometry Protocol™</p>

        <div className="mt-10 grid gap-3 text-left sm:grid-cols-3" data-id="element-323" data-mp="1vwjhzibrwio7">
          <p className="rounded-2xl bg-white/10 p-5 text-[16px] leading-relaxed text-brand-50" data-id="element-324" data-mp="1zwtmsrntx31h">
            <strong className="block text-white" data-id="element-325" data-mp="24udasjabwu6m">It’s not another endless course.</strong>
          </p>
          <p className="rounded-2xl bg-white/10 p-5 text-[16px] leading-relaxed text-brand-50" data-id="element-326" data-mp="29v0z2x76awx5">
            It is not intended to replace a complete professional Apometry training.
          </p>
          <p className="rounded-2xl bg-white/10 p-5 text-[16px] leading-relaxed text-brand-50" data-id="element-327" data-mp="2itlcbitysedz">
            It’s a 7-day practical experience that turns Apometry-inspired concepts into an{' '}
            <strong className="text-white" data-id="element-328" data-mp="2sjo63l8wtwdd">organized routine.</strong>
          </p>
        </div>

        <CtaButton label="I want my 7-day path" className="mt-12" data-id="element-329" data-mp="2xkvadabugdfa" />
      </div>
    </section>;
}